import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";


const CreditReport = () => {
   const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);
  const [loading, setLoading] = useState(false);

  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [uid, setUid] = useState("");

  const [walletBalance, setWalletBalance] = useState(null);
  const [creditPrice, setCreditPrice] = useState(null);

  const [isActive, setIsActive] = useState(false);

  const [status, setStatus] = useState("");
  const [creditScore, setCreditScore] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");

  const [transactionId, setTransactionId] = useState(null);

  const customerId = 101;

  useEffect(() => {
  dispatch(fetchUserProfile());
}, [dispatch]);

useEffect(() => {
  if (profile?.superAdminId) {
    fetchWalletInfo();
  }
}, [profile?.superAdminId]);
  const fetchWalletInfo = async () => {
        const superAdminId = profile?.superAdminId ;

    try {
      const res = await axios.get(
        `https://payyug.in/api/cibil-profile-optional?superAdminId=${superAdminId}`
      );

      const data = res.data.data;

      setWalletBalance(data.wallet);
      setCreditPrice(data.eqfprice);
      setIsActive(data.isActive);
          setUid(data.uid);

    } catch (e) {
      console.error("Failed to load wallet info");
    }
  };

  const deductWallet = async () => {
    try {
      const newBalance = walletBalance - creditPrice;

      const res = await axios.put(
        `https://payyug.in/api/cibil-wallet/${uid}`,
        {
          wallet: newBalance,
        }
      );

      if (res.status === 200) {
        setWalletBalance(newBalance);

        toast.success(
          "Wallet debited successfully"
        );
      }
    } catch (e) {
      toast.error(
        "Wallet deduction failed"
      );
    }
  };

  const startCreditCheck = async () => {
    if (!isActive) {
      toast.error(
        "Account Inactive. Please contact support."
      );
      return;
    }

      const superAdminId = profile?.superAdminId;

    if (!fullName.trim()) {
      toast.error("Please enter full name");
      return;
    }

    if (
      !/^[6-9]\d{9}$/.test(mobile)
    ) {
      toast.error(
        "Please enter valid mobile number"
      );
      return;
    }

    if (
      walletBalance === null ||
      creditPrice === null
    ) {
      toast.error("Wallet not loaded");
      return;
    }

    if (creditPrice === 0) {
      toast.error(
        "Verification price not set"
      );
      return;
    }

    if (
      walletBalance < creditPrice ||
      walletBalance === 0
    ) {
      toast.error(
        "Insufficient wallet balance"
      );
      return;
    }

    try {
      setLoading(true);
// 
      const res = await axios.post(
        "https://payyug.in/api/credit/initiate",
        {
          customerId,
          fullName,
          mobile,
          uid,
          superAdminId
        },
        {
          headers: {
            "Content-Type":
              "application/json",
          },
        }
      );

      const data = res.data;

      const redirectUrl =
        data.redirect_url;

      if (data.transactionId) {
        setTransactionId(
          data.transactionId
        );
      }

      if (redirectUrl) {
        await deductWallet();

        window.open(
          redirectUrl,
          "_blank"
        );
      }
    } catch (e) {
      toast.error(
        "Failed to initiate credit check"
      );
    } finally {
      setLoading(false);
    }
  };

  const checkCreditStatus =
    async () => {
      if (!transactionId) {
        toast.error(
          "Transaction not found"
        );
        return;
      }

      try {
        setLoading(true);

        const res =
          await axios.get(
            `https://payyug.in/api/credit/status?transactionId=${transactionId}`
          );

        const data = res.data;

        setStatus(
          data.status || ""
        );

        setCreditScore(
          data.creditScore
        );

        setPdfUrl(
          data.pdfUrl || ""
        );
      } catch (e) {
        toast.error(
          "Failed to check status"
        );
      } finally {
        setLoading(false);
      }
    };

  const openPdf = () => {
    if (pdfUrl) {
      window.open(
        pdfUrl,
        "_blank"
      );
    }
  };

  // return (


  //   <div
  //     style={{
  //       maxWidth: 500,
  //       margin: "30px auto",
  //       padding: 20,
  //       border:
  //         "1px solid #ddd",
  //       borderRadius: 10,
  //     }}
  //   >
  //     <h2>
  //       Check Credit Score
  //     </h2>

  //     {walletBalance !== null &&
  //       creditPrice !== null && (
  //         <div
  //           style={{
  //             background:
  //               "#f5f5f5",
  //             padding: 10,
  //             borderRadius: 8,
  //             marginBottom: 20,
  //           }}
  //         >
  //           <b>
  //             Wallet ₹
  //             {walletBalance}
  //           </b>

  //           <br />

  //           <b>
  //             Price ₹
  //             {creditPrice}
  //           </b>
  //         </div>
  //       )}

  //     <input
  //       type="text"
  //       placeholder="Full Name"
  //       value={fullName}
  //       onChange={(e) =>
  //         setFullName(
  //           e.target.value
  //         )
  //       }
  //       style={{
  //         width: "100%",
  //         padding: 10,
  //         marginBottom: 10,
  //       }}
  //     />

  //     <input
  //       type="text"
  //       placeholder="Mobile Number"
  //       maxLength={10}
  //       value={mobile}
  //       onChange={(e) =>
  //         setMobile(
  //           e.target.value
  //         )
  //       }
  //       style={{
  //         width: "100%",
  //         padding: 10,
  //         marginBottom: 20,
  //       }}
  //     />

  //     <button
  //       onClick={
  //         startCreditCheck
  //       }
  //       disabled={loading}
  //     >
  //       {loading
  //         ? "Loading..."
  //         : "Check Credit Score"}
  //     </button>

  //     <button
  //       onClick={
  //         checkCreditStatus
  //       }
  //       style={{
  //         marginLeft: 10,
  //       }}
  //     >
  //       Refresh Status
  //     </button>

  //     {status && (
  //       <div
  //         style={{
  //           marginTop: 20,
  //         }}
  //       >
  //         <h3>
  //           Status : {status}
  //         </h3>

  //         {creditScore && (
  //           <h3>
  //             Score :
  //             {creditScore}
  //           </h3>
  //         )}

  //         {pdfUrl && (
  //           <button
  //             onClick={
  //               openPdf
  //             }
  //           >
  //             Open PDF
  //           </button>
  //         )}
  //       </div>
  //     )}
  //   </div>
  // );
  return (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background:
        "linear-gradient(135deg, #f4f7ff 0%, #e8f0ff 100%)",
      padding: "20px",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "500px",
        background: "#fff",
        borderRadius: "20px",
        padding: "30px",
        boxShadow:
          "0 15px 40px rgba(0,0,0,0.08)",
      }}
    >
      <div
        style={{
          textAlign: "center",
          marginBottom: "25px",
        }}
      >
        <div
          style={{
            width: "70px",
            height: "70px",
            borderRadius: "50%",
            background:
              "linear-gradient(135deg,#2563eb,#4f46e5)",
            margin: "0 auto 15px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            fontSize: "30px",
          }}
        >
          📊
        </div>

        <h2
          style={{
            margin: 0,
            color: "#1f2937",
          }}
        >
          Credit Score Check
        </h2>

        <p
          style={{
            color: "#6b7280",
            marginTop: "8px",
          }}
        >
          Check your latest credit score instantly
        </p>
      </div>

      {walletBalance !== null &&
        creditPrice !== null && (
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginBottom: "20px",
            }}
          >


{/* 
            <div
              style={{
                flex: 1,
                background: "#ecfdf5",
                padding: "15px",
                borderRadius: "12px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  color: "#059669",
                  fontSize: "14px",
                }}
              >
                Wallet Balance
              </div>
              <h3
                style={{
                  margin: "5px 0",
                  color: "#065f46",
                }}
              >
                ₹{walletBalance}
              </h3>
            </div> */}


{/* 
            <div
              style={{
                flex: 1,
                background: "#eff6ff",
                padding: "15px",
                borderRadius: "12px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  color: "#2563eb",
                  fontSize: "14px",
                }}
              >
                 Price
              </div>
              <h3
                style={{
                  margin: "5px 0",
                  color: "#1d4ed8",
                }}
              >
                ₹{creditPrice}
              </h3>
            </div> */}


          </div>
        )}

      <input
        type="text"
        placeholder="Enter Full Name"
        value={fullName}
        onChange={(e) =>
          setFullName(e.target.value)
        }
        style={{
          width: "100%",
          padding: "14px",
          borderRadius: "12px",
          border: "1px solid #d1d5db",
          marginBottom: "15px",
          outline: "none",
          fontSize: "15px",
          boxSizing: "border-box",
        }}
      />

      <input
        type="text"
        placeholder="Enter Mobile Number"
        maxLength={10}
        value={mobile}
        onChange={(e) =>
          setMobile(e.target.value)
        }
        style={{
          width: "100%",
          padding: "14px",
          borderRadius: "12px",
          border: "1px solid #d1d5db",
          marginBottom: "20px",
          outline: "none",
          fontSize: "15px",
          boxSizing: "border-box",
        }}
      />

      <button
        onClick={startCreditCheck}
        disabled={loading}
        style={{
          width: "100%",
          padding: "14px",
          border: "none",
          borderRadius: "12px",
          background:
            "linear-gradient(135deg,#2563eb,#4f46e5)",
          color: "#fff",
          fontWeight: "600",
          fontSize: "15px",
          cursor: "pointer",
          marginBottom: "10px",
        }}
      >
        {loading
          ? "Processing..."
          : "Check Credit Score"}
      </button>

      {/* <button
        onClick={checkCreditStatus}
        style={{
          width: "100%",
          padding: "14px",
          border: "1px solid #2563eb",
          borderRadius: "12px",
          background: "#fff",
          color: "#2563eb",
          fontWeight: "600",
          cursor: "pointer",
        }}
      >
        Refresh Status
      </button> */}

      {status && (
        <div
          style={{
            marginTop: "25px",
            padding: "20px",
            borderRadius: "15px",
            background: "#f9fafb",
            textAlign: "center",
          }}
        >
          <h3
            style={{
              color: "#111827",
            }}
          >
            Status : {status}
          </h3>

          {creditScore && (
            <div
              style={{
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  color: "#6b7280",
                }}
              >
                Credit Score
              </div>

              <h1
                style={{
                  color: "#16a34a",
                  margin: 0,
                }}
              >
                {creditScore}
              </h1>
            </div>
          )}

          {pdfUrl && (
            <button
              onClick={openPdf}
              style={{
                marginTop: "15px",
                padding:
                  "12px 25px",
                border: "none",
                borderRadius: "10px",
                background: "#16a34a",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Download Report PDF
            </button>
          )}
        </div>
      )}
    </div>
  </div>
);
};

export default CreditReport;